import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setBranding } from '../../store/branding/action';

/**
 * Custom Hook for consuming branding state in UI components.
 * usage: const { isBrandingActive, brandPrefix } = useBranding();
 */
export const useBranding = () => {
    const isBrandingActive = useSelector((state) => state.branding?.branding ?? false);

    return {
        isBrandingActive
    };
};

/**
 * Headless component to handle branding initialization logic.
 * Place this once in App.js or similar.
 */
const Branding = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        const hostname = window.location.hostname;
        console.log("hostname", hostname);
        const brandingDomains = ['crmit.app', 'crmit.co.uk', 'localhost'];
        // const brandingDomains = [];

        const isBrandingRequired = brandingDomains.some(domain => hostname.includes(domain));
  console.log("isBrandingRequired", isBrandingRequired);
        dispatch(setBranding(isBrandingRequired));
    }, [dispatch]);

    // Renders nothing, just handles logic
    return null;
};

export default Branding;
